import { render, staticRenderFns } from "./shopinfo.vue?vue&type=template&id=9f5e49b6&scoped=true&"
import script from "./shopinfo.vue?vue&type=script&lang=js&"
export * from "./shopinfo.vue?vue&type=script&lang=js&"
import style0 from "./shopinfo.vue?vue&type=style&index=0&id=9f5e49b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5e49b6",
  null
  
)

export default component.exports